<template>
    <ldc-dialog
        :title="title"
        :colorTitle="colorTitle"
        :clickoutside="true"
        width="50%"
        :fullscreen="$detect == 'mobile'"
        :class="{
            'product-dialog' : true,
            'modal-register-vip': $detect == 'web',
            'modal-mobile-vip position-relative': $detect == 'mobile',
            'modal-dght' : action == 'edit',
        }"
        :visible.sync="dialog">
        <div class="content-modal py-3 px-10px">
            <div :class="{
                    'd-flex mt-3' :  $detect == 'web',
                    'd-inline-block mt-3 w-100' :  $detect == 'mobile',
                }">
                <div :class="{
                                'w-40' : $detect == 'web',
                                'd-flex fw-600 w-100' : $detect == 'mobile'
                            }">
                    <div class="name">Cập nhật trạng thái đơn hàng:</div>
                </div>
                <div :class="{
                        'w-60' :  $detect == 'web',
                        'w-100 mt-2' : $detect == 'mobile'
                    }">
                    <div class="value">
                         <ldc-select
                            v-model="status"
                            placeholder="Trạng thái đơn hàng"
                            class="rv-select-form" v-if="$detect == 'web'">
                            <ldc-option 
                                v-for="(index, key) in arrStatusOrder" :key="key"
                                :value="key"
                                :label="index.title"/>
                        </ldc-select>
                        <ldc-select-mobile
                            :showPlaceholder="false"
                            placeholder="Trạng thái đơn hàng"
                            title="Trạng thái đơn hàng"
                            v-model="status"
                            class="select-mobile-post"
                            v-else>
                            <ldc-option-mobile
                                v-for="(index, key) in arrStatusOrder" :key="key"
                                :value="key"
                                :label="index.title"/>
                        </ldc-select-mobile>
                    </div>
                </div>
            </div>
            <div :class="{
                        'd-flex mt-3' : $detect == 'web',
                        'd-inline-block mt-3 w-100' : $detect == 'mobile'

                }">
                <div :class="{
                            'w-40' : $detect == 'web',
                            'fw-600 w-100' :  $detect == 'mobile'
                        }">
                    <div class="name">Ghi chú đơn hàng của bạn:</div>
                </div>
                <div :class="{
                        'w-60' : $detect == 'web',
                        'w-100 mt-2' :  $detect == 'mobile'
                    }">
                    <div class="value">
                       <textarea :class="{
                            'border-primary' : value != '',
                            'w-100 border-textarea' : true
                        }" 
                        id="inputOtherInfo"
                        v-model="value"
                        rows="5"></textarea>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-modal text-center">
            <button :class="{
                    'btn btn-confirm my-10px mr-10px': true,
                    'btn-sm': $detect == 'web'
                }"
                :disabled="loading"
                @click="submit()"
                >Xác nhận</button>
           <!--  <button :class="{
                    'btn btn-danger my-10px mr-10px': true,
                    'btn-sm': $detect == 'web'
                }"
                v-if="checkDataLink"
                @click="del()"
                >Hủy cài đặt</button> -->
        </div>
    </ldc-dialog>
</template>
<script>
export default {
    props: ['visible', 'data', 'action', 'multiple', 'dataMultiple', 'arrStatusOrder'],
    data() {
        return {
            dialog: false,
            title: '',
            oneManipulation: {},
            colorTitle: '',
            actionMuti: false,
            total: 0,
            loading: false,
            source_pay: this.$detect == 'web' ? 0: 1,
            max_amount : 0,
            value: '',
            status : 0,
        }
    },
    watch: {
        visible(val){
            this.dialog = val;
            
        },
        dialog(val){
            this.$emit('update:visible', val);
            
        },
        action(val){
            this.title = 'Cập nhật trạng thái đơn hàng';
            this.oneManipulation = this.config.con_raovat_super_vip_price;
            this.colorTitle = '#20c997';
        },
        data(val){
            this.status = String(val.ord_status); 
            this.value = val.ord_estore_note;
        },
       
    },
    created (){

    },
    mounted(){

    },
    computed: {
        config(){
            return this.$store.state.config;
        },
    },
    methods: {
        submit(){
            apiPost('v2/profile/products/update_order', {
                record_id: this.data.ord_id,
                value: this.value,
                status : this.status
            }).then(res => {
                this.$message({
                        message: res.message,
                        type: 'success',
                        center: true,
                    });
                this.dialog = false;
                this.loading = false;
            }).catch(err => {
                if(err.status == 410){
                    this.$message({
                        message: err.data.message,
                        type: 'error',
                        center: true,
                    });
                    
                 }
            })
        },
    }
}
</script>
<style lang="scss">
.border-textarea{
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    padding: 10px;
}
.m-0-auto{
    margin: 0 auto;
}
.n-cat{
    padding-top: 10px;
}
.bor-top{
    border-top: 1px solid #e5e5e5;
}
.select-mobile-post{
    border: 1px solid #e5e5e5;
    border-radius: 4px;
    .ion-md-arrow-dropdown{
        float: right;
    }
}
.modal-mobile-vip{
    &.modal-HappyLink{
        .title-dialog{
            background : #dc3545;
        }
    }
    &.modal-dght{
        .title-dialog{
            background : #20c997;
        }
    }
}
.title-cat{
    margin-bottom: 0;
    color: #007bff;
}
.undo-icon{
    font-size: 19px;
    color: #007bff;

}
.add-icon{
    color : #20c997;
}
.image-icon{
    width : 42px;
    height : 42px;
}
.incate{
    font-size : 11px;
    color: #dc3545;
}
.w-100px{
    width : 100px;
}
.w-155{
    width : 155px !important;
}
.modal-mobile-vip{
    .content-modal{
        margin-top : 0;
    }
    &.modal-HappyLink {
        .footer-modal{
            .btn-confirm, .btn-danger{
                width: 40%;
            }
        }
    }
}
    .modal-register-vip, .modal-mobile-vip{
        &.modal-HappyLink{
            .title-dialog {
                border-bottom: 1px solid #dc3545;
            }
            .footer-modal{
                border-top: 1px solid #dc3545;
                .btn-confirm{
                    color: white;
                    background : #dc3545;
                }
            }
        }
        &.modal-dght {
            .title-dialog {
                border-bottom: 1px solid #20c997;
            }
            .footer-modal{
                border-top: 1px solid #20c997;
                .btn-confirm{
                    color: white;
                    background : #20c997;
                }
            }
        }
    }
    .product-dialog{
        .content-change-time{
            .date-change{
                height: 35px;
                border-radius: 4px;
                border: 1px solid rgba(0, 0, 0, 0.2);
                color: #606266;
                outline: none;
                cursor: pointer;
            }
        }

        .content-modal{
            .value{
                .select-dght{
                    height: 35px;
                    border-radius: 4px;
                    border: 1px solid rgba(0, 0, 0, 0.2);
                    color: #606266;
                    outline: none;
                    cursor: pointer;
                    width: 155px;
                }
                .input-link{
                    width: 95.5%;
                }
                .border-none{
                    border : unset;
                }
                .input-price-vip{
                    width: 155px;
                    color : #dc3545;
                }
                .span-happy-link{
                    border: unset;
                }
            } 
        }
    }
    .m_input{
        -webkit-appearance: none;
        background-color: #fff;
        background-image: none;
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        box-sizing: border-box;
        color: #606266;
        display: inline-block;
        height: 40px;
        line-height: 40px;
        outline: none;
        padding: 0 15px;
        width : 100%;
    }
</style>
